// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { TournamentsCountQueryDocument, type TournamentsCountQuery, type TournamentsCountQueryVariables } from './TournamentsCountQuery';

export async function getTournamentsCountQueryClient(variables: TournamentsCountQueryVariables) {
  return fetchGraphqlClient<TournamentsCountQuery, TournamentsCountQueryVariables>(TournamentsCountQueryDocument, "TournamentsCountQuery", { variables });
}
export const useTournamentsCountQuery = (...args: QueryArgs<TournamentsCountQueryVariables>) => useQuery<TournamentsCountQuery, TournamentsCountQueryVariables>(getTournamentsCountQueryClient, ...args);